const files = require.context(
  './api',
  true,
  /^((?!index).)*\.js$/
);

const mockApis = {};

files.keys()
  .forEach(key => {
    const filePath = key.substring(2, key.length - 3);
    const filePaths = filePath.split('/');

    const setItem = (level, apis) => {
      const itemKey = filePaths[level];

      if(level === filePaths.length - 1) {
        const path = `/${itemKey.replace(/-/g, '/')
          .replace(/[$]/g, ':')}`;

        apis[itemKey] = {
          path,
          ...files(key).default
        };
      } else if(level < filePaths.length - 1) {
        if(!apis[itemKey]) {
          apis[itemKey] = {};
        }
        setItem(level + 1, apis[itemKey])
      }
    };

    setItem(0, mockApis)
  });

// FIXME: 沒時間開發中止

export default mockApis;
